module.exports = __webpack_public_path__ + "img/logo.79dda09a.png";